import './services/i18n';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingApi from './components/loading/LoadingApi';

import '/node_modules/flag-icons/css/flag-icons.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.scss';
import { ToastContainer } from 'react-toastify';
import Modals from './components/modal/Modals';
import useWindowSize from './hooks/useWindowSize';
import { observer } from 'mobx-react-lite';
import { cn, scrollToTop } from './utils/utils';
import AppIcon from './components/general/AppIcon';
import { isPathEk } from './utils/routes';
import { kickboardClassName } from './configs/constants';

export default observer(function App() {
    // hooks
    const { pathname } = useLocation();
    useWindowSize();
    const { i18n } = useTranslation();

    // lifecycle
    useEffect(() => {
        // Set initial language
        handleLanguageChange(i18n.language);

        // Listen for language changes
        i18n.on('languageChanged', handleLanguageChange);

        // Clean up listener on unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    useEffect(() => {
        scrollToTop();
    }, [pathname]);

    const handleLanguageChange = (lng: string) => {
        document.documentElement.lang = lng;
    };

    return (
        <div
            className={cn(
                'app',
                isPathEk(pathname) && kickboardClassName
            )}
            translate='no'
        >
            <Outlet />
            <LoadingApi />
            <ToastContainer />
            <Modals />
            <AppIcon />
        </div>
    );
});
